import styled from '@emotion/styled';
import React, { useState } from 'react';

import { IconConceal, IconReveal } from '../../common/design-tokens/Icons';
import { ButtonText } from '../shared/Buttons';
import FloatingLabelInput from '../shared/FloatingLabelInput';

const InputContainer = styled.div`
  position: relative;
`;

type Props = {
  showPassword?: boolean;
  toggleShowPassword?: () => void;
} & React.ComponentProps<typeof FloatingLabelInput>;

const ShowPasswordsButton = styled(ButtonText, {
  shouldForwardProp: (prop) => prop !== 'showPassword',
})<{ showPassword: boolean }>`
  position: absolute;
  right: 0;
  top: 12px;

  path {
    opacity: ${({ showPassword }) => (showPassword ? 1 : 0.5)};
  }
`;

const PasswordInput = styled(FloatingLabelInput)`
  & input {
    padding-right: 32px;
  }
`;

export default function PasswordField(props: Props) {
  const [showPasswordInner, setShowPasswordInner] = useState(false);
  const {
    showPassword: showPasswordControlled,
    toggleShowPassword: toggleShowPasswordControlled,
    ...rest
  } = props;
  const showPassword =
    showPasswordControlled === undefined
      ? showPasswordInner
      : showPasswordControlled;
  const toggleShowPassword =
    toggleShowPasswordControlled ??
    (() => setShowPasswordInner((state) => !state));
  return (
    <InputContainer>
      <PasswordInput type={showPassword ? 'text' : 'password'} {...rest} />
      {toggleShowPassword && (
        <ShowPasswordsButton
          size="xxsmall"
          icon="icon only"
          rounded
          type="button"
          onClick={toggleShowPassword}
          showPassword={showPassword}
          aria-label={showPassword ? 'Hide password' : 'Show password'}
        >
          {showPassword ? (
            <IconReveal aria-hidden />
          ) : (
            <IconConceal aria-hidden />
          )}
        </ShowPasswordsButton>
      )}
    </InputContainer>
  );
}
